import React from 'react';
import PropTypes from 'prop-types';

const SocialContent = ({active}) => {
    return (
        <div className="social-content" style={{opacity: active ? '1' : '0'}}>
            <a href="http://facebook.com/unrealtournament/" target="_blank" rel="noopener noreferrer">
                <span><i className="icon-facebook" /></span>
            </a>
            <a href="http://twitter.com/utgame" target="_blank" rel="noopener noreferrer">
                <span><i className="icon-twitter" /></span>
            </a>
            <a href="http://youtube.com/unrealtournament" target="_blank" rel="noopener noreferrer">
                <span><i className="icon-youtube" /></span>
            </a>
            <a href="https://www.twitch.tv/unrealtournament" target="_blank" rel="noopener noreferrer">
                <span><i className="icon-twitch" /></span>
            </a>
        </div>
    )
};

SocialContent.propTypes = {
    active: PropTypes.bool
};

SocialContent.defaultProps = {
    active: true
};

export default SocialContent;
